import { RoutePrefix } from '#/routing/classes/RoutePrefix';

export const viewUserProfilePrefix = new RoutePrefix('/i');

export const viewUserProfilePath = viewUserProfilePrefix.path(':username');
